import React from "react";
import { resolveAvatarUrl } from "../utils/avatarUrl";

export default function UserAvatar({ avatarUrl, name, className = "", title, size = 38 }) {
    const src = resolveAvatarUrl(avatarUrl);
    const letter = (name || "?").slice(0, 1).toUpperCase();

    if (src) {
        return (
            <img
                src={src}
                alt=""
                width={size}
                height={size}
                className={`user-avatar-img ${className}`.trim()}
                title={title}
                decoding="async"
            />
        );
    }

    return (
        <div className={className} title={title} aria-hidden={title ? undefined : true}>
            {letter}
        </div>
    );
}
